import React from 'react';
import { Box, Typography } from '@mui/material';
import DashboardCard from '../../../common/DashboardCard';
import DashboardButton from '../../../common/DashboardButton';

/**
 * Reusable component for settings sections
 * 
 * @param {node} icon - Icon for the section
 * @param {string} title - Section title
 * @param {string} subtitle - Section subtitle/description
 * @param {node} content - Content to display
 * @param {function} onConfigureClick - Function called when configure button is clicked
 */
const SettingsSection = ({
  icon,
  title,
  subtitle,
  content,
  onConfigureClick
}) => {
  return (
    <DashboardCard
      elevation={1}
      animation="hover"
      sx={{ height: '100%' }}
      title={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box 
            sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              width: 40, 
              height: 40, 
              borderRadius: '12px',
              backgroundColor: 'primary.lighter',
              color: 'primary.main'
            }}
          >
            {icon}
          </Box>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
        </Box>
      }
      subtitle={subtitle}
      footer={
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
          <DashboardButton
            variant="contained"
            size="small"
            onClick={onConfigureClick}
            animation="scale"
          >
            Configure
          </DashboardButton>
        </Box>
      }
    >
      <Box sx={{ py: 1 }}>
        {content}
      </Box>
    </DashboardCard>
  );
};

export default SettingsSection;